module.exports = __webpack_public_path__ + "cab2bb44ba2148f35c48b338d3361163.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/_stay_alt.png
 ** module id = 662
 ** module chunks = 0
 **/